import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#1B2A4A]" data-id="element-54">
      {/* Star of David tiled texture */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' stroke='%23ffffff' stroke-width='0.6'%3E%3Cpolygon points='30,12 46,39 14,39'/%3E%3Cpolygon points='30,48 14,21 46,21'/%3E%3C/g%3E%3C/svg%3E\")"
    }} data-id="element-55" />
      {/* Subtle vignette for depth */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, transparent 50%, rgba(0,0,0,0.25) 100%)'
    }} data-id="element-56" />

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 text-center mt-20" data-id="element-57">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="space-y-8" data-id="element-58">
          {/* Subtitle */}
          <motion.div variants={itemVariants} className="inline-block" data-id="element-59">
            <span className="text-[#B8860B] text-sm md:text-base font-medium tracking-[0.2em] uppercase mb-4 block" data-id="element-60">
              The Legacy of Ze'ev Jabotinsky
            </span>
            {/* Decorative gold line */}
            <div className="flex items-center justify-center gap-3 mt-4" data-id="element-61">
              <div className="w-12 h-px bg-gradient-to-r from-transparent to-[#B8860B]/60" data-id="element-62" />
              <div className="w-1.5 h-1.5 rotate-45 bg-[#B8860B]/60" data-id="element-63" />
              <div className="w-12 h-px bg-gradient-to-l from-transparent to-[#B8860B]/60" data-id="element-64" />
            </div>
          </motion.div>

          {/* Heading */}
          <motion.h1 variants={itemVariants} className="text-5xl md:text-7xl lg:text-8xl font-serif text-[#F5F0E8] leading-tight" data-id="element-65">
            The Iron Wall <br className="hidden md:block" data-id="element-66" />
            <span className="italic text-[#F5F0E8]/90" data-id="element-67">of Ideas</span>
          </motion.h1>

          {/* Quote */}
          <motion.div variants={itemVariants} className="max-w-3xl mx-auto mt-12" data-id="element-68">
            <blockquote className="text-xl md:text-2xl text-[#F5F0E8]/70 font-serif italic leading-relaxed border-l-2 border-[#B8860B]/50 pl-6 text-left" data-id="element-69">
              "We were not created in order to teach morals and manners to our
              enemies. Let them learn these things for themselves before they
              establish relations with us."
            </blockquote>
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 2,
      duration: 1
    }} className="absolute bottom-12 left-1/2 transform -translate-x-1/2" data-id="element-70">
        <a href="#about" aria-label="Scroll down" className="text-[#F5F0E8]/50 hover:text-[#B8860B] transition-colors duration-300" data-id="element-71">
          <motion.div animate={{
          y: [0, 10, 0]
        }} transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'easeInOut'
        }} data-id="element-72">
            <ChevronDown size={32} strokeWidth={1.5} data-id="element-73" />
          </motion.div>
        </a>
      </motion.div>
    </section>;
}